import { NotificationOutlet } from "./notification-outlet";
import { NotificationRuntimeProvider } from "./notification-runtime-context";
import { notificationModules } from "./notifications";

const NotificationService = () => {
  return (
    <NotificationRuntimeProvider>
      {notificationModules.map(({ id, Resolver }, priority) => (
        <Resolver key={id} priority={priority} />
      ))}
      <NotificationOutlet />
    </NotificationRuntimeProvider>
  );
};

export default NotificationService;
